import { environment } from '../environments/environment';

const baseUrl = `${location.hostname}:${location.port}`;
export const baseHttpUrl = `${location.protocol}//${baseUrl}`;
export const  baseWsUrl = `${location.protocol === 'http:' ? 'ws:' : 'wss:'}//${baseUrl}`;

